import * as actionTypes from './actionTypes';

export const toggle4DCommissionUpdate=()=>{
      return {
            type:actionTypes.TOGGLE_4D_COMMISSION_UPDATE
      }
}